import { z } from 'zod';

import { AI_MODEL_TYPE_OPTIONS } from './constants';

export const zodAiModelEntrySchema = z.object({
  modelId: z.string().trim().min(1),
  modelType: z.enum(AI_MODEL_TYPE_OPTIONS).prefault('di'),
});
